import React, { useEffect } from "react";
import { EditOutlined, PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import { Button, Form, Image, Input, Popconfirm, Select } from "antd";
import TextArea from "antd/es/input/TextArea";

import ButtonWrapper from "../../components/reuseComp/ButtonWrapper";
import { SectionField } from "./HomeTabs";
import UploadImage from "../../components/UploadImage";
import { useInsightList } from "../../../hooks/api/insight/hooks";


export interface OurThinkingProps {
  heading?: string;
  subtext?: string;
  selectedArticle: string[];
}

interface Props {
  isEditing: boolean;
  setIsEditing: (v: boolean) => void;
  handleCancel: () => void;
  handleSave: () => void;
  onDelete: (index: number, field: SectionField) => void;
  form: any;
  ourThinking?: OurThinkingProps;
  loading?: boolean;
  mode: "list" | "add" | "edit";
  setMode: (value: "list" | "add" | "edit") => void;
  editingIndex: number | null;
  setEditingIndex: (value: number | null) => void;
}

const OurThinking: React.FC<Props> = ({
  isEditing,
  setIsEditing,
  handleCancel,
  handleSave,
  form,
  ourThinking,
  loading,
  mode,
}) => {
  const allowURLStateUpdate = true 
  const DEFAULT_NUQS_CONFIG = {
    throttleMs: !allowURLStateUpdate ? Infinity : 0,
  };

  const {data} = useInsightList({page: 1, limit: 20, ...DEFAULT_NUQS_CONFIG});
  const insightList = data?.data
  useEffect(() => {
    if (!ourThinking) return;

    form.setFieldsValue({
      ourThinking: {
        heading: ourThinking.heading || "",
        subtext: ourThinking.subtext || "",
        selectedArticle:
          ourThinking.selectedArticle?.map((s: any) => s._id) || [],
      },
    });

  }, [mode, ourThinking, form]);

  return (
    
    <div>
      {!isEditing ? (
        <>
          <div className="rounded-[20px] overflow-hidden">
            <table className="hidden min-w-full sm:table">
              <thead>
                <tr className="bg-primary text-white">
                  <th className="py-3 px-4 text-left">Heading</th>
                  <th className="py-3 px-4 text-left">Subtext</th>
                  <th className="py-3 px-4 text-right">Action</th>
                </tr>
              </thead>

              <tbody>
                {ourThinking ? (
                  <tr className="bg-[#F9F9F9] border-b">
                    <td className="py-3 px-4 ">
                      {ourThinking?.heading}
                    </td>
                    <td className="py-3 px-4 ">
                      {ourThinking?.subtext}
                    </td>
                    <td className="py-3 px-4 text-right text-primary">
                      <EditOutlined
                        onClick={() => setIsEditing(true)}
                        className="cursor-pointer text-[20px]"
                      />
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td colSpan={3} className="text-center py-6">
                      <Button type="dashed" onClick={() => setIsEditing(true)}>
                        Add Data
                      </Button>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            <div className="bg-[#F9F9F9] border-b sm:block hidden">
              <div className="py-3 px-4">
                <Form layout="vertical" form={form}>
                  <Form.Item
                    label="Select Insights"
                    name={["ourThinking", "selectedArticle"]}
                  >
                    <Select
                      mode="multiple"
                      placeholder="Select Insights"
                      options={insightList?.map((insight) => ({
                        label: insight?.heading,
                        value: insight?._id,
                      }))}
                    />
                  </Form.Item>
                </Form>

                <ButtonWrapper
                  type="primary"
                  onClick={handleSave}
                  loading={loading}
                >
                  Save
                </ButtonWrapper>
              </div>
            </div>
          </div>

          <div className="sm:hidden block">
            {ourThinking ? (
              <div className="bg-[#F9F9F9] border rounded-lg mb-4 p-4 space-y-3">
                <p>
                  <b className="text-primary">Heading:</b> <div>{ourThinking?.heading}</div>
                </p>
                <p>
                  <b className="text-primary">Subtext:</b> <div>{ourThinking?.subtext}</div>
                </p>

                <EditOutlined
                  onClick={() => setIsEditing(true)}
                  className="cursor-pointer text-[20px] text-primary"
                />
              </div>
            ) : (
              <div className="text-center py-6">
                <Button type="dashed" onClick={() => setIsEditing(true)}>
                  Add Data
                </Button>
              </div>
            )}

            <div className="bg-[#F9F9F9] border rounded-lg">
              <div className="py-3 px-4">
                <Form layout="vertical" form={form}>
                  <Form.Item
                    label="Select Insight"
                    name={["ourThinking", "selectedArticle"]}
                  >
                    <Select
                      mode="multiple"
                      placeholder="Select articles"
                      options={insightList?.map((insight) => ({
                        label: insight?.heading,
                        value: insight?._id,
                      }))}
                    />
                  </Form.Item>
                </Form>

                <ButtonWrapper
                  type="primary"
                  onClick={handleSave}
                  loading={loading}
                >
                  Save
                </ButtonWrapper>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div>
          <div className="bg-[#F9F9F9] p-4 rounded-lg">
            <Form layout="vertical" form={form}>
              <Form.Item
                label="Heading"
                name={["ourThinking", "heading"]}
                rules={[{ required: true, message: "Please enter heading" }]}
              >
                <Input placeholder="Heading" />
              </Form.Item>

              <Form.Item
                label="Subtext"
                name={["ourThinking", "subtext"]}
                rules={[{ required: true, message: "Please enter subtext" }]}
              >
                <TextArea rows={3} placeholder="Subtext" />
              </Form.Item>
            </Form>
          </div>

          <div className="flex gap-3 mt-6">
            <ButtonWrapper
              type="primary"
              onClick={handleSave}
              loading={loading}
            >
              Save
            </ButtonWrapper>

            <ButtonWrapper onClick={handleCancel}>Cancel</ButtonWrapper>
          </div>
        </div>
      )}
    </div>
  );
};

export default OurThinking;
